// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import type {HelpCenterArticleSlug} from '@app/features/app/config/HelpCenterConstants';

// The marketing site has no help articles yet, so every slug resolves to its home page.
export function getURL(_slug: HelpCenterArticleSlug): string {
	return Routes.help();
}
